import { render, staticRenderFns } from "./partner-dialog.vue?vue&type=template&id=89ffd4c2&"
import script from "./partner-dialog.vue?vue&type=script&lang=js&"
export * from "./partner-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports